import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveDirective as _resolveDirective, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  "data-bs-backdrop": "false",
  id: "newUserModal",
  ref: "newTargetModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content rounded" }
const _hoisted_4 = { class: "modal-header pt-8 pb-5 px-10" }
const _hoisted_5 = { class: "modal-title fs-2 fw-bold" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", {
  "data-bs-dismiss": "modal",
  class: "pointer"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "isax-close-circle text-white fs-2x pointer" })
], -1)
const _hoisted_8 = { class: "modal-body scroll-y px-10 px-lg-15 pt-0 pb-15" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "mb-13 text-center" }, null, -1)
const _hoisted_10 = { class: "row g-9 mb-2" }
const _hoisted_11 = { class: "col-md-6 fv-row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-base fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Nombre")
], -1)
const _hoisted_13 = { class: "input-group mb-1" }
const _hoisted_14 = { class: "input-group-text" }
const _hoisted_15 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_16 = { class: "col-md-6 fv-row" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-base fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Apellidos")
], -1)
const _hoisted_18 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_19 = { class: "d-flex flex-column mb-2" }
const _hoisted_20 = { class: "fv-row" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-base fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Correo electrónico")
], -1)
const _hoisted_22 = { class: "input-group mb-1" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "input-group-text fs-3" }, "@", -1)
const _hoisted_24 = ["readonly"]
const _hoisted_25 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_26 = { class: "d-flex flex-column mb-2" }
const _hoisted_27 = { class: "fv-row" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-base fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Teléfono")
], -1)
const _hoisted_29 = { class: "input-group mb-1" }
const _hoisted_30 = { class: "input-group-text" }
const _hoisted_31 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_32 = { class: "d-flex flex-column mb-2" }
const _hoisted_33 = { class: "fv-row" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-base fw-bold mb-2" }, "Rol", -1)
const _hoisted_35 = { class: "input-group mb-1" }
const _hoisted_36 = { class: "input-group-text" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: 0
}, "Selecciona rol", -1)
const _hoisted_38 = ["label", "value"]
const _hoisted_39 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_40 = {
  key: 0,
  class: "d-flex flex-column mb-2 fv-row"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-base fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Agencia")
], -1)
const _hoisted_42 = { class: "input-group mb-1" }
const _hoisted_43 = { class: "input-group-text" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: []
}, "Selecciona agencia(s)", -1)
const _hoisted_45 = ["label", "value"]
const _hoisted_46 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_47 = { class: "d-flex justify-content-between px-6" }
const _hoisted_48 = { class: "align-self-center fs-base" }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "separator" }, null, -1)
const _hoisted_51 = {
  key: 1,
  class: "d-flex flex-column mb-2"
}
const _hoisted_52 = { class: "fv-row" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-base fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Ciudad")
], -1)
const _hoisted_54 = { class: "input-group mb-1" }
const _hoisted_55 = { class: "input-group-text" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ''
}, "Asigna la ciudad del valuador", -1)
const _hoisted_57 = ["value"]
const _hoisted_58 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_59 = { class: "d-flex flex-row justify-content-center mt-10" }
const _hoisted_60 = { class: "me-3 mb-3 mb-md-0" }
const _hoisted_61 = ["data-kt-indicator"]
const _hoisted_62 = {
  key: 0,
  class: "indicator-label fs-base"
}
const _hoisted_63 = {
  key: 1,
  class: "indicator-progress fs-base"
}
const _hoisted_64 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, [
            _createTextVNode(_toDisplayString(_ctx.type == "create" ? "Nuevo usuario" : "Editar usuario") + " ", 1),
            (_ctx.nameAgency)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "en agencia " + _toDisplayString(_ctx.nameAgency), 1))
              : _createCommentVNode("", true)
          ]),
          _hoisted_7
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_form, {
            id: "kt_modal_new_target_form",
            onSubmit: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
            model: _ctx.targetData,
            rules: _ctx.rules,
            ref: "formRef",
            class: "form"
          }, {
            default: _withCtx(() => [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("span", _hoisted_14, [
                      _createVNode(_component_inline_svg, { src: "media/icons/iconsax/user.svg" })
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control fs-base text-gray-700",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.targetData.name) = $event)),
                      placeholder: "Nombre",
                      name: "name",
                      onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.removeError('nombre')))
                    }, null, 544), [
                      [_vModelText, _ctx.targetData.name]
                    ])
                  ]),
                  (_ctx.errorNombre)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, "El nombre es obligatorio"))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control fs-base text-gray-700",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.targetData.last_name) = $event)),
                    placeholder: "Apellidos",
                    name: "last_name",
                    onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.removeError('apellidos')))
                  }, null, 544), [
                    [_vModelText, _ctx.targetData.last_name]
                  ]),
                  (_ctx.errorApellidos)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Los apellidos son obligatorios"))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control fs-base text-gray-700",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.targetData.email) = $event)),
                      placeholder: "Correo",
                      readonly: _ctx.type == '',
                      name: "email",
                      onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.removeError('correo')))
                    }, null, 40, _hoisted_24), [
                      [_vModelText, _ctx.targetData.email]
                    ])
                  ]),
                  (_ctx.errorEmail)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, "Error en el correo"))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("span", _hoisted_30, [
                      _createVNode(_component_inline_svg, { src: "media/icons/iconsax/call.svg" })
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "tel",
                      class: "form-control fs-base text-gray-700",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.targetData.phone) = $event)),
                      placeholder: "Número de teléfono",
                      name: "phone",
                      onBlur: _cache[7] || (_cache[7] = ($event: any) => (_ctx.removeError('telefono')))
                    }, null, 544), [
                      [_vModelText, _ctx.targetData.phone],
                      [_directive_maska, {
                      mask: 'Z#-##-##-##-##',
                      tokens: { Z: { pattern: /[1-9]/ } },
                    }]
                    ])
                  ]),
                  (_ctx.errorTelefono)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_31, "El teléfono es obligatorio"))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _hoisted_34,
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("span", _hoisted_36, [
                      _createVNode(_component_inline_svg, { src: "media/icons/iconsax/crown-1.svg" })
                    ]),
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select text-gray-700",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.targetData.id_role) = $event)),
                      placeholder: "Selecciona rol",
                      name: "id_role",
                      onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.getRolFromUser(_ctx.targetData.id_role)))
                    }, [
                      _hoisted_37,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (item) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: item.id,
                          label: item.name_rol,
                          value: item.id
                        }, _toDisplayString(item.name_rol), 9, _hoisted_38))
                      }), 128))
                    ], 544), [
                      [_vModelSelect, _ctx.targetData.id_role]
                    ])
                  ]),
                  (_ctx.errorRol)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_39, "El rol es obligatorio"))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_ctx.showAgencias)
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                    _hoisted_41,
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("span", _hoisted_43, [
                        _createVNode(_component_inline_svg, { src: "media/icons/iconsax/shop.svg" })
                      ]),
                      _withDirectives(_createElementVNode("select", {
                        class: "form-select text-gray-700",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.targetData.agency) = $event)),
                        placeholder: "Selecciona agencia(s)",
                        name: "agency",
                        onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.addAgency(_ctx.targetData.agency)))
                      }, [
                        _hoisted_44,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agencies, (itemAgency) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: itemAgency.id,
                            label: itemAgency.name,
                            value: itemAgency
                          }, _toDisplayString(itemAgency.name), 9, _hoisted_45))
                        }), 128))
                      ], 544), [
                        [_vModelSelect, _ctx.targetData.agency]
                      ])
                    ]),
                    (_ctx.errorAgencia)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_46, "La agencia es obligatoria"))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedAgencies, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("span", _hoisted_48, _toDisplayString(Object.values(item)[0]), 1),
                          _createElementVNode("span", {
                            class: "btn btn-sm btn-icon-white btn-active-icon-white",
                            onClick: ($event: any) => (_ctx.removeAgency(index))
                          }, [
                            _createVNode(_component_inline_svg, { src: "media/icons/iconsax/close-circle.svg" })
                          ], 8, _hoisted_49)
                        ]),
                        _hoisted_50
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showCiudad)
                ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, [
                      _hoisted_53,
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("span", _hoisted_55, [
                          _createVNode(_component_inline_svg, { src: "media/icons/iconsax/map.svg" })
                        ]),
                        _withDirectives(_createElementVNode("select", {
                          class: "form-select text-gray-700",
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.targetData.city) = $event)),
                          placeholder: "Asigna la ciudad del valuador",
                          name: "city",
                          onChange: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.cambiaCiudad && _ctx.cambiaCiudad(...args)))
                        }, [
                          _hoisted_56,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.citiesCat, (city, index) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: index,
                              value: city
                            }, _toDisplayString(city), 9, _hoisted_57))
                          }), 128))
                        ], 544), [
                          [_vModelSelect, _ctx.targetData.city]
                        ])
                      ]),
                      (_ctx.errorCiudad)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_58, "La ciudad es obligatoria"))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("button", {
                    class: "btn btn-lg btn-secondary me-3 mb-3 fs-base",
                    type: "button",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.closeModal()))
                  }, " Cancelar ")
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    "data-kt-indicator": _ctx.loading ? 'on' : null,
                    class: "btn btn-lg btn-primary",
                    type: "submit"
                  }, [
                    (!_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_62, _toDisplayString(_ctx.targetData.id > 0 ? "Actualizar" : "Guardar"), 1))
                      : _createCommentVNode("", true),
                    (_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_63, [
                          _createTextVNode(" Guardando... "),
                          _hoisted_64
                        ]))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_61)
                ])
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ])
    ])
  ], 512))
}